import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from './AuthContext'

export function GuestRoute() {
  const { isAuthenticated, isAuthChecking } = useAuth()
  if (isAuthChecking) return null
  if (isAuthenticated) return <Navigate to="/" replace />
  return <Outlet />
}
